import {SubsidyDetails} from 'src/types/SubsidyDetails';
import Localized from 'src/constants/AppStrings';

export interface SubsidyDetailField {
  key: string;
  title: string;
  value: string | string[];
  testID: string;
}

export const buildSubsidyDetailFields = (
  subsidyDetails: SubsidyDetails,
): SubsidyDetailField[] => {
  const fields: SubsidyDetailField[] = [];

  fields.push({
    key: 'groupName',
    title: Localized.Labels.group_name,
    value: subsidyDetails.groupName,
    testID: 'qa_Subsidy_GroupName',
  });

  if (
    subsidyDetails.validDaysTimes &&
    subsidyDetails.validDaysTimes.length > 0
  ) {
    fields.push({
      key: 'validDaysTimes',
      title: Localized.Labels.valid_days_times,
      value: subsidyDetails.validDaysTimes,
      testID: 'qa_Subsidy_ValidDaysTimes',
    });
  }

  if (subsidyDetails.subsidyType) {
    fields.push({
      key: 'subsidyType',
      title: Localized.Labels.subsidy_type,
      value: subsidyDetails.subsidyType,
      testID: 'qa_Subsidy_Type',
    });
  }

  if (subsidyDetails.recurrence) {
    fields.push({
      key: 'recurrence',
      title: Localized.Labels.recurrence,
      value: subsidyDetails.recurrence,
      testID: 'qa_Subsidy_Recurrence',
    });
  }

  return fields;
};
